// Weighted random testimonial picker that never repeats a quote within `gap` picks.

const norm = (s) => String(s || "").trim().toLowerCase().replace(/\s+/g, " ");

export function dedupeTestimonials(list) {
  const seen = new Map();
  for (const t of list) {
    const key = norm(t.quote);
    if (!key) continue;
    const prev = seen.get(key);
    if (!prev || (t.weight || 1) > (prev.weight || 1)) seen.set(key, t);
  }
  return [...seen.values()];
}

/** Index of the next item; excludes the last `gap` indices in `history`. */
export function pickNext(items, history, gap = 8, rand = Math.random) {
  const recent = new Set(history.slice(-Math.min(gap, items.length - 1)));
  const pool = items.map((t, i) => i).filter((i) => !recent.has(i));
  const total = pool.reduce((s, i) => s + (items[i].weight || 1), 0);
  let r = rand() * total;
  for (const i of pool) {
    r -= items[i].weight || 1;
    if (r < 0) return i;
  }
  return pool[pool.length - 1];
}
